export default __webpack_public_path__ + "static/media/copper_personal.efe68958.svg";